export default __webpack_public_path__ + "static/media/full-elf.635ae487.jpg";